import {
  Button,
  Divider,
  IconButton,
} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { AddRounded as AddIcon } from '@material-ui/icons';
import { putMedia, getMedias } from '@webapps/business';
import {
  Modal,
  useAuth,
  useMutation,
  useToast,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import * as React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import CreateMediaForm from './CreateMediaForm';
import MediaCard from './MediaCard';

const EditMedia = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const { addToast } = useToast();

  const [creation, setCreation] = useState(false);
  const [media, setMedia] = useState([]);

  const { isSuccess, mutateAsync: mutatePutMedia } = useMutation(putMedia);

  const { data: { content: mediasContent = [] } = {}, refetch } = useQuery(getMedias, {
    key: ['medias', idUser],
    variables: {
      id: typeof idParam !== 'undefined' ? idParam : idUser,
      page: 0,
      size: 1000,
    },
  });

  useEffect(() => {
    setMedia(mediasContent);
  }, [mediasContent]);

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
    }
  }, [isSuccess]);

  const [dndContainer, setDndContainer] = useState('dndcontainer');
  const dndContainerRef = React.useRef();
  dndContainerRef.current = dndContainer;

  const handleOnDragStart = () => {
    setDndContainer('dndcontainerActive');
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    // reorder items by index in table
    const items = Array.from(media);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // set priority = index + 1 for the "0"
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < items.length; i++) {
      if (items[i]) items[i].priority = i + 1;
    }
    // reset media for display
    setMedia(items);

    handleSendUpdate(media);
  };

  const handleSendUpdate = async (info) => {
    await mutatePutMedia({
      data: info,
      id: idUser,
    });
    setDndContainer('dndcontainer');
  };

  return (
    <div className={classes.container}>
      <div className={classes.editContainer}>
        <div>
          <div className={cx(global.title, classes.title)}>Médias</div>
          <div className={cx(global.infoText, classes.subTitle)}>
            Importez vos vidéos ou photos.
            <br /> Les deux premiers médias sont définis par défaut comme étant
            "Épinglé".
            <br /> Pour modifier l'ordre, déplacez directement les médias
            publiés selon l'ordre souhaité.
          </div>
        </div>
        <div>
          <IconButton
            className={css({
              background: '#F3F7FF',
              border: '1px solid #C0D9FF',
              width: '30px',
              height: '30px',
            })}
            onClick={() => setCreation(true)}
            size="small"
          >
            <AddIcon style={{ color: '#5A6DA1', fontSize: '24px' }} />
          </IconButton>
        </div>
      </div>
      <Divider style={{ marginBottom: spacing(2.5) }} />
      <div className={classes.title} style={{ marginBottom: spacing(2.5) }}>
        {media.length ? media.length + ' médias publiés' : 'Aucun média publié'}
      </div>
      <div
        className={css({
          display: 'block',
          '@media (max-width:1100px)': { display: 'none !important' },
        })}
      >
        <div className={classes[dndContainerRef.current]}>
          <DragDropContext
            onDragEnd={handleOnDragEnd}
            onDragStart={handleOnDragStart}
          >
            <Droppable direction="vertical" droppableId="idMedias">
              {(provided) => (
                <div
                  className={cx(classes.all, 'idMedias')}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {media.map(
                    (
                      { description, id, label, path, priority, type, title },
                      index
                    ) => (
                      <Draggable key={id} draggableId={id} index={index}>
                        {(providedTwo) => (
                          <Paper
                            ref={providedTwo.innerRef}
                            {...providedTwo.draggableProps}
                            {...providedTwo.dragHandleProps}
                            className={classes.blockContainer}
                            elevation={0}
                          >
                            <MediaCard
                              description={description}
                              label={label}
                              path={path}
                              priority={priority}
                              type={type}
                              title={title}
                              id={id}
                              refetch={refetch}
                            />
                          </Paper>
                        )}
                      </Draggable>
                    )
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className={classes.buttonSend}>
            <Button
              color="primary"
              disabled={dndContainerRef.current !== 'dndcontainerActive'}
              className={classes.btn}
              onClick={() => handleSendUpdate(media)}
              variant="contained"
            >
              Enregistrer les modifications
            </Button>
          </div>
        </div>
      </div>
      <div
        className={css({
          display: 'block',
          '@media (min-width:1101px)': { display: 'none !important' },
        })}
      >
        <div className={classes[dndContainerRef.current]}>
          <DragDropContext
            onDragEnd={handleOnDragEnd}
            onDragStart={handleOnDragStart}
          >
            <Droppable direction="vertical" droppableId="idMedias">
              {(provided) => (
                <div
                  className={cx(classes.all, 'idMedias')}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {media.map(
                    (
                      { description, id, label, path, priority, type, title },
                      index
                    ) => (
                      <Draggable key={id} draggableId={id} index={index}>
                        {(providedTwo) => (
                          <Paper
                            ref={providedTwo.innerRef}
                            {...providedTwo.draggableProps}
                            {...providedTwo.dragHandleProps}
                            className={classes.blockContainer}
                          >
                            <MediaCard
                              description={description}
                              label={label}
                              path={path}
                              priority={priority}
                              type={type}
                              title={title}
                              id={id}
                              refetch={refetch}
                            />
                          </Paper>
                        )}
                      </Draggable>
                    )
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className={classes.buttonSend}>
            <Button
              color="primary"
              disabled={dndContainerRef.current !== 'dndcontainerActive'}
              className={classes.btn}
              onClick={() => handleSendUpdate(media)}
              variant="contained"
            >
              Enregistrer les modifications
            </Button>
          </div>
        </div>
      </div>
      <Modal
        onCancel={() => setCreation(false)}
        open={creation}
        title="Ajouter un média"
        withStep={false}
      >
        <CreateMediaForm
          close={() => setCreation(false)}
          data={media}
          refetch={refetch}
        />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: 'white',
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
    padding: '20px',
    marginBottom: '25px',
  },
  subTitle: {
    marginTop: '8px',
    marginBottom: '20px',
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'top',
  },
  dndcontainer: {
    backgroundColor: '#F3F7FF',
    padding: spacing(2),
    borderRadius: 10,
    '@media only screen and (max-width: 768px)': {
      height: 'auto',
      overflowY: 'visible',
    },
  },
  dndcontainerActive: {
    backgroundColor: '#F3F7FF',
    padding: spacing(2),
    borderRadius: 10,
    '@media only screen and (max-width: 768px)': {
      height: 'auto',
      overflowY: 'visible',
    },
  },
  blockContainer: {
    width: '49%',
    textAlign: 'center',
    padding: spacing(2.5),
    borderRadius: 10,
    backgroundColor: 'white',
    marginBottom: spacing(2),
    '@media (max-width:1101px)': { width: '45%' },
    '@media (max-width:1100px)': { width: '90%' },
  },
  block: {
    minHeight: '22vh',
    borderRadius: 10,
    padding: spacing(2),
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    '@media (max-width:768px)': { minHeight: '10vh' },
  },
  all: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: 'auto',
    justifyContent: 'space-between',
  },
  buttonSend: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export default EditMedia;
